module.exports = __webpack_public_path__ + "8021354340bd22ceb1318e6efcef1581.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/eagles-nest.png
// module id = 554
// module chunks = 0